import React from "react";
import {Route} from "react-router-dom";
import InsertOrderBorrowerContainer
    from "../../pages/ptt/valuesRequest/insertOrderBorrower/InsertOrderBorrowerContainer";
import UpdateOrderBorrowerContainer
    from "../../pages/ptt/valuesRequest/updateOrderBorrower/UpdateOrderBorrowerContainer";
import {SET_ORDER_BORROWER_ROUTE, UPDATE_ORDER_BORROWER_ROUTE} from "../../utils/constants/RoutesConstants";

const BorrowerRoutes = () => {
    return (
        <React.Fragment>
            <Route path={SET_ORDER_BORROWER_ROUTE} component={InsertOrderBorrowerContainer}/>
            <Route path={UPDATE_ORDER_BORROWER_ROUTE} component={UpdateOrderBorrowerContainer}/>
        </React.Fragment>
    );
};

export default BorrowerRoutes;